import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const CohortBuilderLoadingTemplate = () => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Skeleton
          height={24}
          width={'30%'}
          sx={{
            margin: '24px 20px 0 24px',
          }}
        />
        <Skeleton
          height={40}
          width={'20%'}
          sx={{
            margin: '24px 20px 0 24px',
          }}
        />
      </Box>
      <Skeleton
        height={'48px'}
        width={'50%'}
        sx={{
          margin: '0 20px 10px 24px',
          transform: 'none',
        }}
      />
      <Skeleton
        height={24}
        width={'40%'}
        sx={{
          margin: '0 20px 0 24px',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          height: '400px',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            margin: '20px 20px 0 24px',
            width: '236px',
            height: '450px',
            transform: 'none',
          }}
        >
          <Skeleton
            height={'48px'}
            width={'100%'}
            sx={{ marginBottom: '5px', transform: 'none' }}
          />
          <Skeleton
            height={'48px'}
            width={'100%'}
            sx={{ marginBottom: '5px', transform: 'none' }}
          />
          <Skeleton
            height={'48px'}
            width={'100%'}
            sx={{ marginBottom: '5px', transform: 'none' }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            margin: '20px 20px 0 24px',
            width: '85%',
          }}
        >
          <Skeleton
            height={'32px'}
            width={'100px'}
            sx={{ marginBottom: '15px', transform: 'none' }}
          />
          <Skeleton
            height={'14px'}
            width={'400px'}
            sx={{ marginBottom: '15px', transform: 'none' }}
          />
          <Skeleton
            height={'150px'}
            width={'100%'}
            sx={{ marginBottom: '15px', transform: 'none' }}
          />
          <Skeleton
            height={'150px'}
            width={'100%'}
            sx={{ marginBottom: '5px', transform: 'none' }}
          />
        </Box>
      </Box>
    </>
  );
};
